import { useState } from 'react';

import { faRefresh } from '@fortawesome/pro-regular-svg-icons';
import { match } from 'ts-pattern';

import { translate } from '@cloud-wave/neon-common-lib/app';

import Button, { BUTTON_SIZES } from 'lib/common/components/Button/Button';

import { useAIContext } from '../../../Context';
import { StreamingText } from '../../IQCritique/components/StreamingText/StreamingText';
import SlideInEffect from '../SlideInEffect/SlideInEffect';

import styles from './iq-request-error.module.scss';

const IQRequestError = () => {
  const {
    actions: { retryFailedRequest },
    state: { selectedAction },
  } = useAIContext();
  const [animationDone, setAnimationDone] = useState(false);

  const snagWhileText = match(selectedAction)
    .with('REWRITE', () => 'rewriting')
    .with('FEEDBACK', () => 'evaluating')
    .with('SPELLING', () => 'checking')
    .with('SUMMARIZE', () => translate('summarise').slice(0, -1) + 'ing')
    .with(null, () => 'processing')
    .exhaustive();

  return (
    <SlideInEffect direction="right">
      <div className={styles['iq-request-error']}>
        <StreamingText
          text={`Oops! I hit a snag while ${snagWhileText} your content. Please try again - I'm ready when you are.`}
          onComplete={() => setAnimationDone(true)}
        />
        {animationDone && (
          <Button
            onClick={retryFailedRequest}
            className={styles['iq-request-error__button']}
            icon={faRefresh}
            size={BUTTON_SIZES.SMALL}
          >
            Try Again
          </Button>
        )}
      </div>
    </SlideInEffect>
  );
};

export default IQRequestError;
